/** @format */

import React from 'react';
import NumberFormat from 'react-number-format';
import {
    ORDER_STATUS_QUOTE,
    GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_LABEL
} from 'frontier-constants';
import {Icon, Modal, ModalFooter, ModalHeader} from '@sttark/design-system';
import {CartForm} from './form/cart_form';
import {ConditionalButton, withUploadHandler} from 'frontier-utilities';
import ModalPortal, {ModalClose} from 'frontier-admin/modal/container_portal';
import {parseEntityError} from 'frontier-form';

// styles
import './order.sass';
import SuperAgent from 'superagent';
import dot from 'dot-object';
import {OrderDisplayMeta} from 'frontier/cart/components/cart_overview/chunks/order_display_meta';
import {prettyProductLabel} from 'frontier/ds/quoter/functions/format';
import {AccountContext} from 'frontier-utilities';
import {
    MODAL_SAVE_LATER,
    MODAL_EDIT,
    MODAL_DELETE_ORDER,
    MODAL_LOGIN,
    MODAL_UPLOAD_ARTWORK,
    MODAL_REMOVE_FROM_CART
} from './modal_constants';
import QuoteLoginModal from 'frontier/ds/quoter/quote_login_modal';
import {Button} from '@sttark/design-system';

const withOrderHandler = Component => {
    return class extends React.Component {
        static defaultProps = {
            designs: [],
            values: [],
            totalOrderCount: 1
        };
        constructor(props) {
            super(props);

            this.state = {
                saving: false,
                open: false //this.props.orderIndex === 1 ? true : false
            };
        }

        handleToggle = () => {
            this.setState({open: !this.state.open});
        };

        handleSave = () => {
            this.setState({saving: true}, async () => {
                try {
                    const {
                        body: {order}
                    } = await SuperAgent.post(`/carts/save-to-account/${this.props.id}`)
                        .set('accept', 'application/json')
                        .send({customer_label: this.props.customer_label});

                    this.props.onSavedToAccount(this.props.id);
                } catch (e) {
                    const error = parseEntityError(dot.pick('response.body', e));
                    this.setState({error, saving: false});
                }
            });
        };

        render() {
            const props = {...this.props};

            props.onToggle = this.handleToggle;
            props.onSave = this.handleSave;
            return <Component {...props} {...this.state} />;
        }
    };
};

class GraphicDesignOrder extends React.Component {
    static contextType = AccountContext;
    state = {
        expanded: false,
        displaySaved: false,
        showModal: 0
    };

    isSaving = fieldName => {
        return (
            this.props.fieldsSaving &&
            this.props.fieldsSaving.findIndex(
                x => x.orderId === this.props.id && x.fieldName === fieldName
            ) > -1
        );
    };

    orderMeta = () => {
        const order = this.props;
        const designOrder = order.graphic_design_order_details;
        let values = [];
        values.push({label: 'format', value: order.shape_label});
        values.push({label: 'size', value: order.size_label});
        values.push({label: 'material', value: order.substrate_label});
        if (designOrder.design_type_id === GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN) {
            values.push({
                label: 'style',
                value: designOrder.design_style_preferences_label
            });
            values.push({
                label: 'color',
                value: designOrder.color_preferences_label
            });
        }
        values.push({
            label: 'designs',
            value: order.design_qty > 1 ? order.design_qty + ' Designs' : '1 Design'
        });

        return values;
    };

    render() {
        const {
            id,
            onSave,
            onDelete,
            orderStatus,
            designs_orders,
            graphic_design_order_details,
            product_type_id,
            saving,
            quoted_total
        } = this.props;
        return (
            <div>
                {/* Save for Later Modal */}
                <Modal
                    onClose={() => this.setState({showModal: 0})}
                    isOpen={this.state.showModal === MODAL_SAVE_LATER}
                    zIndex={3000}
                    bodyHeightAuto>
                    <ModalHeader onClose={() => this.setState({showModal: 0})}>
                        Save for Later
                    </ModalHeader>
                    <div>
                        <p className="mb-2 mt-0 mx-0">
                            <b>Do you wish to proceed?</b>
                        </p>
                        <p className="mt-0">
                            Saving a cart item for later adds it to the Saved Quotes page within
                            your user account page.
                        </p>
                    </div>
                    <ModalFooter>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button
                                onClick={() => this.setState({showModal: 0})}
                                label="Cancel"
                                secondary
                            />
                            <Button
                                onClick={() => {
                                    this.setState({showModal: 0});

                                    if (this.context.user?.is_logged_in) onSave();
                                    else this.setState({showModal: MODAL_LOGIN});
                                }}
                                label="Save for Later"
                            />
                        </div>
                    </ModalFooter>
                </Modal>

                {/* Login Modal */}
                {this.state.showModal === MODAL_LOGIN && (
                    <ModalPortal
                        onClose={() => this.setState({showModal: 0})}
                        noCard={true}
                        maxWidth="700px">
                        <div style={{background: 'white', padding: '20px', position: 'relative'}}>
                            <ModalClose onClose={() => this.setState({showModal: 0})} />
                            <QuoteLoginModal
                                orderId={this.props.id}
                                defaultLabel={this.props.customer_label}
                                onLogin={this.handleLogin}
                                onShowCreateAccount={() => {}}
                            />
                        </div>
                    </ModalPortal>
                )}

                {/* Edit Modal*/}
                <Modal
                    onClose={() => this.setState({showModal: 0})}
                    isOpen={this.state.showModal === MODAL_EDIT}
                    zIndex={3000}
                    bodyHeightAuto>
                    <ModalHeader onClose={() => this.setState({showModal: 0})}>
                        Edit Item
                    </ModalHeader>
                    <div>
                        <p className="mb-2 mt-0 mx-0">
                            <b>You will be taken back to the Quoter.</b>
                        </p>
                        <p className="mt-0">
                            From there, you can edit all details of this item. Changes to this cart
                            item will be automatically saved and the item will be updated in the
                            cart.
                        </p>
                    </div>
                    <ModalFooter>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button
                                onClick={() => this.setState({showModal: 0})}
                                label="Cancel"
                                secondary
                            />
                            <Button
                                onClick={() =>
                                    (window.location = `/orders/custom-design/${id}?edit`)
                                }
                                label="Edit Item"
                            />
                        </div>
                    </ModalFooter>
                </Modal>

                {/* Delete Order */}
                <Modal
                    onClose={() => this.setState({showModal: 0})}
                    isOpen={this.state.showModal === MODAL_DELETE_ORDER}
                    zIndex={3000}
                    bodyHeightAuto>
                    <ModalHeader onClose={() => this.setState({showModal: 0})}>
                        Delete Order
                    </ModalHeader>
                    <div>
                        <p className="mb-2 mt-0 mx-0">
                            <b>Do you wish to proceed?</b>
                        </p>
                        <p className="mt-0">
                            You are about to remove an item from your cart. This action cannot be
                            undone.
                        </p>
                    </div>
                    <ModalFooter>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button
                                onClick={() => this.setState({showModal: 0})}
                                label="Cancel"
                                secondary
                            />
                            <Button
                                onClick={() => {
                                    this.setState({showModal: 0});
                                    onDelete();
                                }}
                                label={'Delete'}
                                destructive
                            />
                        </div>
                    </ModalFooter>
                </Modal>

                <div
                    className={`order-container d-flex align-items-center justify-content-center
                    ${
                        orderStatus === ORDER_STATUS_QUOTE
                            ? 'cart-order order-incomplete'
                            : 'cart-order'
                    }`}>
                    <div className="order-container_card">
                        {/* if the order is incomplete */}
                        {orderStatus === ORDER_STATUS_QUOTE && (
                            <div>
                                <h5 className="founders-sb error-header">
                                    Incomplete Order. Please complete your order to checkout
                                </h5>
                                <a
                                    href={
                                        '/orders/custom-design/' +
                                        id +
                                        '?edit&showErrorsFromCart=true'
                                    }
                                    className="btn btn-sm btn-complete">
                                    Complete Order
                                </a>
                            </div>
                        )}

                        {/*order detials: major card container */}
                        <div className="cart-order-container">
                            <div className="cart-order-details d-flex align-items-center">
                                {/* design preview */}
                                {designs_orders.length > 0 && (
                                    <div className="designs-contianer designs-contianer--graphic-designs">
                                        <div
                                            className="designs graphic-design--designs"
                                            style={{
                                                backgroundImage: `url(${designs_orders[0].signed_url})`
                                            }}></div>
                                    </div>
                                )}

                                {/* order item header Mobile only*/}
                                <div className="item-meta-header--mobile bg-structure-lightest mt-0 mx-0 mb-4 w-100 border-bottom border-dark ">
                                    <h6 className="m-0 ps-3">item</h6>
                                </div>

                                {/* order meta */}
                                <div className="product-meta mx-0 mt-0 mb-auto">
                                    {/*Title: Item size and type */}
                                    <div className="mx-0 mt-0 mb-2 d-flex align-items-center justify-content-start">
                                        <h3 className="m-0 text-left tw-p-0 product_size-label">
                                            {prettyProductLabel(
                                                graphic_design_order_details.product_label,
                                                product_type_id,
                                                graphic_design_order_details.design_type_id
                                            )}
                                        </h3>
                                        <button
                                            className="btn--primary py-0 px-3 product-meta_edit"
                                            onClick={() => this.setState({showModal: 2})}>
                                            Edit
                                        </button>
                                    </div>

                                    {/* order display meta  */}
                                    <OrderDisplayMeta props={this.props} />

                                    {/*order controls */}
                                    <div className="mx-0 mt-0 mb-2 d-flex align-items-center justify-content-start cart-order-controls">
                                        <button
                                            className="cart-order-controls_control tw-p-0 d-flex align-items-center justify-content-start"
                                            onClick={() =>
                                                this.setState({expanded: !this.state.expanded})
                                            }>
                                            <Icon name="view" small color="black" />
                                            <span>View All Details</span>
                                        </button>
                                        <ConditionalButton enabled={saving}>
                                            <button
                                                className="btn btn-sm tw-p-0"
                                                disabled="disabled">
                                                <i
                                                    className="fa fa-spin fa-spinner"
                                                    style={{marginRight: '10px'}}
                                                />
                                            </button>
                                            <button
                                                className="m-0 tw-p-0 cart-order-controls_control d-flex align-items-center justify-content-start"
                                                onClick={() => this.setState({showModal: 1})}>
                                                <i
                                                    className="fa fa-save"
                                                    style={{marginRight: '3px'}}
                                                />
                                                <Icon name="save" small color="black" />
                                                <span>Save for Later</span>
                                            </button>
                                        </ConditionalButton>
                                    </div>
                                </div>

                                {/* item totals header. Mobile only*/}
                                <div className="item-total-header--mobile bg-structure-lightest mt-5 mx-0 mb-4 w-100 border-bottom border-dark ">
                                    <h6 className="m-0">Qty</h6>
                                    <h6 className="m-0">Unit</h6>
                                    <h6 className="m-0">Subtotal</h6>
                                </div>

                                {/* order qty */}
                                <div className="product-qty"></div>

                                {/* price per unit*/}
                                <div className="cart-order-unit"></div>

                                {/*order subtotal*/}
                                <h5 className="cart-order-subtotal tw-pt-2 align-self-start">
                                    <NumberFormat
                                        displayType={'text'}
                                        value={
                                            orderStatus === ORDER_STATUS_QUOTE ? 0.0 : quoted_total
                                        }
                                        prefix={'$'}
                                        decimalScale={0}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                    />
                                </h5>
                            </div>
                            <div className="cart-order_footer d-flex align-items-center justify-content-between">
                                <p className="m-0 designs_qty-placeholder text-end"></p>
                                <p className="m-0 designs_qty-placeholder text-end"></p>
                            </div>

                            {/* order call to action. Mobile only*/}
                            <div className="cart-order_cta-container--mobile">
                                <Button
                                    className="edit-button--mobile w-100 mt-4 mb-4"
                                    label={'Edit'}
                                    primary
                                    onClick={() => this.setState({showModal: 2})}
                                />

                                <div className="cart-order_cta--mobile w-100 mb-4 d-block">
                                    <h6
                                        className="text-center my-0 m-auto"
                                        onClick={() =>
                                            this.setState({
                                                expanded: !this.state.expanded
                                            })
                                        }>
                                        View All Details
                                    </h6>
                                </div>
                                <div className="cart-order_cta--mobile w-100  mb-4 d-block">
                                    <h6
                                        className="text-center my-0 m-auto"
                                        onClick={() => this.setState({showModal: 1})}>
                                        Save for Later
                                    </h6>
                                </div>
                                <div className="cart-order_cta--mobile w-100  mb-4 d-block">
                                    <h6
                                        className="text-center my-0 m-auto color-alert-negative"
                                        onClick={() => this.setState({showModal: 4})}>
                                        Delete
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Delete */}
                    <div className="order-contianer_delete tw-p-0">
                        {this.isSaving('deleting') && (
                            <span>
                                <i className={'fa fa-spinner fa-spin'} />
                            </span>
                        )}

                        {!this.isSaving('deleting') && (
                            <button
                                className="delete_icon m-0 b-0"
                                onClick={() => this.setState({showModal: MODAL_DELETE_ORDER})}>
                                <Icon name="trash" color="#df3d33" />
                            </button>
                        )}
                    </div>
                </div>

                {this.state.expanded && (
                    <CartForm
                        cta={{handleClose: () => this.setState({expanded: !this.state.expanded})}}
                        cart={{...this.props, isSaving: this.isSaving, orderMeta: this.orderMeta()}}
                    />
                )}
            </div>
        );
    }
}

export default withOrderHandler(withUploadHandler(GraphicDesignOrder));
